<template>
    <div class="full-container service">
       <img :src="require('@/assets/images/bs/bg_1.jpg')" width="100%">
        <div class="full-container res-get" :style="{'background-image': 'url(' + getImg + ')'}">
          <div class="get-title">立即拥有属于您的能源管理平台</div>
          <div class="get-button">扫码获取方案</div>
          <el-image class="get-img" :src="contactQrImg" ></el-image>
        </div>
        <apj-page-contact></apj-page-contact>
    </div>
</template>

<script>
import ApjPageContact from '@/components/apj-page-contact'
import ApjPageBanner from '@/components/apj-page-banner'
export default {
  name: "res",
  components: {
    ApjPageContact,
    ApjPageBanner,
  },
  data() {
    return {
      options: {
        banner: require('@/assets/site/programme_resource_management/banner.jpg'),
        title: "智慧燃气管理系统解决方案",
        text: ''
      },
      img: [
        require('@/assets/site/programme_resource_management/img_1.jpg'),
        require('@/assets/site/programme_resource_management/img_2.jpg'),
        require('@/assets/site/programme_resource_management/img_3.jpg')
      ],
      getImg: require('@/assets/site/contact_bg.jpg'),
      contactQrImg: require('@/assets/site/dp_qr.png'),
      advantage: [
        "分散控制和集中管理相结合",
        "减少管理环节，优化管理流程",
        "减少运营成本，提高劳动生产率",
        "加快异常处理，提高反应能力",
        "节约能源,改善环境"
      ]
    };
  },
  mounted() {
    // 进入页面时，菜单是否透明，或不显示阴影，默认为false，这里是示例
    globalEvent.$emit('changeHeaderTransparent', {
      isTransparent: true,
      isNoShadow: false
    })
    globalEvent.$emit('changeMenu', 3)
    // globalEvent.$emit('pageLoad')
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/theme.scss';

div {
  width: 100%;
}

/** page style */
.res-introduce {
  align-self: flex-start;
  max-width: 1140px;
}
.introduce-container {
  max-width: 1140px;
  padding: 80px;
}

.introduce-container-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}

.res-flow-1 {
  padding: 0px 0 80px;
}
.res-flow-2 {
  height: 550px;
  background-color: $color-bg-grey;
  padding: 0px 0 50px;
  img {
    background-color: $color-bg-white;
    border-radius: 10px;
    box-shadow: 2px 2px 10px #eeeeee;
    padding: 20px;
  }
}
.res-flow-3 {
  padding: 350px 0 80px;
}
.res-items {
  display: flex;
  justify-content: space-between;
  padding: 0 160px;

  .res-item {
    min-height: 220px;
    padding: 15px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid $color-border-grey;

    .res-number {
      width: 40px;
      padding-bottom: 10px;
      margin-bottom: 30px;
      font-size: 30px;
      word-spacing: 10px;
      font-weight: bold;
      border-bottom: 3px solid $color-border-primary;
    }
  }
  .res-item:hover {
    cursor: pointer;
    background-color: $color-bg-primary;
    .res-number {
      color: $color-text-white;
      border-bottom: 3px solid $color-border-white;
    }
    .res-desc {
      color: $color-text-white;
    }
  }
}

.res-get {
  padding-top: 80px;
  margin-top: 50px;
  height: 500px;

  .get-title {
    font-size: 42px;
    line-height: 84px;

  }
  $buttonHeight: 40px;
  .get-button {
    width: 200px;
    height: $buttonHeight;
    border-radius: $buttonHeight;
    line-height: $buttonHeight;
    background-color: $color-bg-primary;
    color: $color-text-white;
  }
  .get-img {
    margin-top: $buttonHeight;
    width: 150px;
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/fuelgas/index.vue